module.exports = __webpack_public_path__ + "static/media/right.939b0b56.svg";